import { useState, useCallback, useEffect } from 'react';
import GridAtom from '@components/atom/grid/grid';
import { AlertOption } from '@classes/options/grid/account/alertGridOption';
import { alertHistoriesArrs, alertTypeObj } from '@models/manager/account/account';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { setAlertBoxType } from '@reducers/account/alertSlice';

const HistoryBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const { historyList } = useSelector(({ alert }: RootState) => alert);

  const [gridChartOption, setGridChartOption] = useState(null);

  // select 선택에 따른 필터링 처리 state
  const [selectFilterObj, setSelectFilterObj] = useState(null);
  // 현재 선택한 selectValues {alertClass, alertType, alertStore} 그리드차트 옵션과 같게 처리해야함
  const [currentSelectedValues, setCurrentSelectedValues] = useState(null);

  // selectArrs
  const { selectAlertClassArr, selectStore, selectTypeArr } = alertHistoriesArrs();

  // create option
  const _option = new AlertOption();

  // useEffect for responseData
  useEffect(() => {
    if (historyList) {
      setGridChartOption(_option.alertHistory(historyList));
    }
  }, [historyList]);

  // useEffect for change SelectOptions
  useEffect(() => {
    if (historyList) {
      if (selectFilterObj) {
        setGridChartOption(_option.alertHistory(historyList, selectFilterObj));
      }
    }
  }, [selectFilterObj]);

  const onChangeSelectHandler = useCallback((event) => {
    const { name, value } = event.target;
    switch (name) {
      case 'alertClass':
        if (value === 'null') {
          setCurrentSelectedValues((prev) => ({ ...prev, alertClass: null }));
        } else {
          setCurrentSelectedValues((prev) => ({ ...prev, alertClass: value }));
        }
        break;
      case 'alertType':
        if (value === 'null') {
          setCurrentSelectedValues((prev) => ({ ...prev, alertType: null }));
        } else {
          setCurrentSelectedValues((prev) => ({ ...prev, alertType: value }));
        }
        break;
      case 'alertStore':
        if (value === 'null') {
          setCurrentSelectedValues((prev) => ({ ...prev, alertStore: null }));
        } else {
          setCurrentSelectedValues((prev) => ({ ...prev, alertStore: value }));
        }
        break;
      default:
        break;
    }
  }, []);

  const onClickSearchHandler = useCallback(() => {
    setSelectFilterObj(currentSelectedValues);
  }, [currentSelectedValues]);

  const onClickMoveList = useCallback(() => {
    dispatch(setAlertBoxType({ boxType: alertTypeObj.listBox })); // alertlist 로 화면 전환처리
  }, [dispatch, setAlertBoxType, alertTypeObj]);

  return (
    <>
      <h2 className="account-tit">Alert History </h2>
      <form>
        <div className="serach-box team">
          <label className="select">
            <select name="alertClass" onChange={onChangeSelectHandler}>
              <option value={'null'}>Select Alert Class </option>
              {selectAlertClassArr.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </label>
          <label className="select">
            <select name="alertType" onChange={onChangeSelectHandler}>
              <option value={'null'}>Select Type</option>
              {selectTypeArr.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </label>
          <label className="select">
            <select name="alertStore" onChange={onChangeSelectHandler}>
              <option value={'null'}>Select Store</option>
              {selectStore.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </label>
          <button type="button" className="btn-s pri" onClick={onClickSearchHandler}>
            Search
          </button>
        </div>
      </form>
      <div className="tb-basic-wrap">
        <GridAtom {...gridChartOption} height={'450px'} />
      </div>
      <div className="account-btn">
        <button type="button" className="btn pri" onClick={onClickMoveList}>
          Back to AlertList
        </button>
      </div>
    </>
  );
};

export default HistoryBox;
